import React from 'react';
import { X, BookOpen, Mail, ExternalLink } from 'lucide-react';

const defaultContent = {
  title: 'Need Help?',
  content: 'We\'re here to help! Check out our documentation or contact support.',
  docsUrl: '/help',
  contactEmail: 'support@acquiva.com'
};

export function HelpPanel({ content, onClose }) {
  const helpContent = content || defaultContent;

  return (
    <div className="mb-3 w-80 bg-white rounded-2xl shadow-2xl border border-neutral-200 overflow-hidden animate-in fade-in slide-in-from-bottom-2 duration-200">
      {/* Header */}
      <div className="px-4 py-3 bg-gradient-to-r from-blue-600 to-cyan-600 flex items-center justify-between">
        <h3 className="font-semibold text-white">{helpContent.title}</h3>
        <button
          onClick={onClose}
          className="text-white/80 hover:text-white transition-colors"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Content */}
      <div className="p-4 space-y-4">
        <p className="text-sm text-neutral-600 leading-relaxed">
          {helpContent.content}
        </p>

        {/* Action Buttons */}
        <div className="space-y-2">
          {helpContent.docsUrl && (
            <a
              href={helpContent.docsUrl}
              className="flex items-center gap-3 px-4 py-3 bg-blue-50 hover:bg-blue-100 rounded-lg border border-blue-200 transition-colors group"
            >
              <div className="w-10 h-10 rounded-full bg-blue-100 group-hover:bg-blue-200 flex items-center justify-center transition-colors">
                <BookOpen className="w-5 h-5 text-blue-600" />
              </div>
              <div className="flex-1">
                <div className="font-medium text-blue-900">Documentation</div>
                <div className="text-xs text-blue-600">Browse help articles</div>
              </div>
              <ExternalLink className="w-4 h-4 text-blue-400" />
            </a>
          )}

          {helpContent.contactEmail && (
            <a
              href={`mailto:${helpContent.contactEmail}`}
              className="flex items-center gap-3 px-4 py-3 bg-neutral-50 hover:bg-neutral-100 rounded-lg border border-neutral-200 transition-colors group"
            >
              <div className="w-10 h-10 rounded-full bg-neutral-100 group-hover:bg-neutral-200 flex items-center justify-center transition-colors">
                <Mail className="w-5 h-5 text-neutral-600" />
              </div>
              <div className="flex-1">
                <div className="font-medium text-neutral-900">Email Support</div>
                <div className="text-xs text-neutral-500">{helpContent.contactEmail}</div>
              </div>
              <ExternalLink className="w-4 h-4 text-neutral-400" />
            </a>
          )}
        </div>

        {/* Keyboard Shortcut Hint */}
        <div className="pt-2 border-t border-neutral-100">
          <p className="text-xs text-neutral-400 text-center">
            Press <kbd className="px-1.5 py-0.5 bg-neutral-100 rounded text-neutral-600 font-mono">?</kbd> anytime for help
          </p>
        </div>
      </div>
    </div>
  );
}

